"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArweaveError =
/*#__PURE__*/
function (_Error) {
  _inherits(ArweaveError, _Error);

  function ArweaveError(type) {
    var _this;

    var optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ArweaveError);

    if (optional.message) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ArweaveError).call(this, optional.message));
    } else {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ArweaveError).call(this));
    }

    _this.type = type;
    _this.response = optional.response;
    return _possibleConstructorReturn(_this);
  }

  _createClass(ArweaveError, [{
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }]);

  return ArweaveError;
}(_wrapNativeSuper(Error));

exports.default = ArweaveError;